var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dropdown",class:['dropdown-menu', `dropdown-${_vm.dropdownPosition}`],style:(_vm.transform)},[(_vm.displayTail)?_c('div',{staticClass:"dropdown-tail-wrapper"}):_vm._e(),_c('div',{staticClass:"dropdown-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }